import {FormFilterClass} from "./modules/FormFilterClass";

const $window = $(window);
const $body = $('body');
import inputAnimation from "./modules/inputAnimation";
new inputAnimation();
import {LazyImage, LazyImages} from "./modules/lazyImages";
import Swiper from "swiper";
import {FormValidation} from "./modules/FormValidation";

/****************************
 *
 * Video load on click
 *
 ***************************/

$('.block-video__circle').on("click", function () {
    let $this = $(this);

    $this.find('.block-video__url').fadeIn();
    var iframe_id = $this.find('.block-video__url__iframe').attr('id');
    var iframe_src = $('#' + iframe_id).data('src');
    $('#' + iframe_id).attr('src', iframe_src + '?autoplay=1');
});


/****************************
 *
 * Image lazy load
 *
 ***************************/

new LazyImages($body, 200);


/****************************
 *
 * FaQ slide down
 *
 ***************************/

$('.faq__title').on("click", function () {
    let $this = $(this);

    $this.toggleClass('rotate-arrow');
    $this.siblings().slideToggle(400);
});

/****************************
 *
 * News overview LazyLoad
 *
 ***************************/

let ajaxContainer = document.getElementById('ajax-results');

new FormFilterClass({
    form: document.getElementById('lazy-search'),
    container: ajaxContainer,
    lazyload: 400,
    loader: document.getElementById('append_loader'),
    onLazyload: () => {
        $(ajaxContainer).find('.lazy-image:not(".active")').each(function () {
            new LazyImage($(this), 200);
        })
    }
});

/****************************
 *
 * Swiper slider
 *
 ***************************/

var mySwiper = new Swiper ('.swiper-container', {
    // Optional parameters
    // loop: true,

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
    },
});

/****************************
 *
 * Navigation mobile toggle
 *
 ***************************/

$('.hamburger').on("click", function () {
    let $this = $(this);
    let nav_bottom = $('.nav-bottom');
    let nav = $('.nav--mobile');
    let triangle = $('.triangle');

    $('html').toggleClass('is-locked');
    $this.toggleClass('is-active');
    nav.toggleClass('nav--mobile--open');

    nav_bottom.toggleClass('nav-bottom--active');
    nav_bottom.slideToggle();

    $('.block-search').hide();
    triangle.addClass('triangle--hide');
    triangle.toggleClass('d-none');
});

/****************************
 *
 * Toggle search icon color on input
 *
 ***************************/

$('.input-search').on('input', function () {
    let $this = $(this);
    let search_label = $('.input-wrapper-label--search');
    let search_wrapper = $('.input-wrapper--search');

    if ($this.val()) {
        search_label.hide();
        search_wrapper.addClass('change');
    } else {
        search_label.show();
        search_wrapper.removeClass('change');
    }
});

/****************************
 *
 * Toggle visibility search icon triangle
 *
 ***************************/

$('.icon--search').on('click', function () {
    let $this = $(this);
    $this.toggleClass('triangle--hide');

   $('.block-search').toggle();
});

/****************************
 *
 * Contact form
 *
 ***************************/

const newsletters = document.getElementsByClassName('contactform');

for (let newsletter of newsletters) {
    new FormValidation($(newsletter), {
        loading: '<i class="fa fa-spinner fa-spin"></i>',
        button: newsletter.querySelector('button'),
        inputGroup: 'input',
        invalidClass: 'is-invalid',
        validClass: '',
        afterSubmit: function () {
            console.log(newsletter);
        },
        onSubmitSuccess: () => {
            newsletter.remove();
            $('.show-after-form-submit').fadeIn();

            let $form = $(newsletter);

            if ($form.data('ga') && window.gtag !== undefined) {
                gtag('event', 'macro-conversie', {
                    'event_category': $form.data('ga'),
                    'event_label': $form.data('url')
                });
            }
        }
    });
}

function scrollToFormTop() {
    $('html, body').animate({
        scrollTop: $('.contactform').offset().top - ($('.contactform').height())
    }, 500);
}

$('select').on('click', function () {
    let $this = $(this);

    $this.css('opacity', 1);
    $('label[for='+  this.id  +']').removeClass('underline');
    $('label[for='+  this.id  +']').addClass('focus');
});

$("textarea").focus(function(){
    $('label[for='+  $this.id  +']').addClass('focus');
});
